var GiftMessageModel = (function (CheckoutApiModel) {
    return CheckoutApiModel.extend({

        defaults: {
            GiftMessage: undefined,

            GiftDate: undefined,

            GiftDateDay: undefined,
            GiftDateMonth: undefined,
            GiftDateYear: undefined,

            GiftOccasion: undefined,

            GiftStyle: undefined
        },

        setData: function (message, giftOccasion, giftDateStr) {
            message !== undefined && this.set('GiftMessage', message);
            giftOccasion !== undefined && this.set('GiftOccasion', giftOccasion);
            giftDateStr !== undefined && this.set('GiftDate', this._parseGiftDate(giftDateStr));
		},

		getMessage: function () {
            return this.get('GiftMessage');
		},

        getHtmlMessage: function () {
            return (this.get('GiftMessage') || '').replace(/(?:\r\n|\r|\n)/g, '<br/>');
		},

        _parseGiftDate: function (dateStr) {
            if (dateStr) {
                dateStr = dateStr.replace(/(\d\d)\/(\d\d)\/(\d\d\d\d)/, '$2/$1/$3');
                var tic = Date.parse(dateStr) || null;
                if (tic) {
                    return new Date(tic);
                }
            }
            return null;
        },

		save: function(message, occasion, date) {
            return api.setGiftParameters({
                giftMessage: message || '',
                giftOccasion: occasion || null,
                giftStyle: null,
                giftDate: date && date.format('dd/mm/yyyy') || null
            }).done(_.bind(function (d) {
                d = d && d.Value || {};
                var _giftDate = this._parseGiftDate(d.GiftDateStr);

                this.set('GiftDate', _giftDate);
                this.set('GiftMessage', d.GiftMessage);
                this.set('GiftOccasion', d.GiftOccasion);
            }, this));
        }
	});
})(CheckoutApiModel);
